<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title">
        Add a new user
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark color="white">fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <v-form>
            <v-text-field :error-messages="messages.first_name" v-model="user.first_name" label="First Name" type="text"
              filled class="input-width">
            </v-text-field>
            <v-text-field :error-messages="messages.last_name" v-model="user.last_name" label="Last Name" type="text"
              filled class="input-width"></v-text-field>
            <v-text-field :error-messages="messages.email" v-model="user.email" label="Email" type="text" filled
              class="input-width"></v-text-field>
            <!-- <v-text-field
              v-model="user.password"
              :error-messages="messages.password"
              label="Password"
              type="password"
              filled
              class="edit-input-width"
            >
              <template slot="append-outer">
                <v-tooltip left>
                  <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                  </template>
                  <span>The password must be at least 8 characters, contain 1 uppercase, 1 lowercase & 1 special Charecter.</span>
                </v-tooltip>
              </template>
            </v-text-field>
            <v-text-field
              v-model="user.confirm_password"
              :error-messages="messages.confirm_password"
              label="Confirm Password"
              type="password"
              filled
              class="edit-input-width"
            >
              <template slot="append-outer">
                <v-tooltip left>
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on">fa fa-question</v-icon>
                  </template>
                  <span>The Confirm Password must be same as password.</span>
                </v-tooltip>
              </template>
            </v-text-field> -->
            <v-select v-model="user.groups" :items="groups" item-text="name" item-value="id" label="Groups" multiple
              chips hint="Assign user to groups" persistent-hint filled attach>
              <template slot="append-outer">
                <v-tooltip left>
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on">fa fa-question</v-icon>
                  </template>
                  <span>Assign user to groups</span>
                </v-tooltip>
              </template>
            </v-select>
            <!--<v-select
              v-model="user.role_id"
              :items="roles"
              item-text="name"
              item-value="id"
              label="Access Level"
              hint="Change User Privledges"
              class="mt-4"
              filled
              >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Change User Privledges</span>
                </v-tooltip>
              </template>
            </v-select>-->
            <v-select v-if="this.locations.length" v-model="user.site_id" :items="filteredLocations"
              :filter="customFilter" :clearable="true" @change="resetSearchTerm" item-text="name" item-value="id"
              :label="$globalConfig.APP_NAME === 'senso' ? 'Sites' : 'Locations'"
              :hint="$globalConfig.APP_NAME === 'senso' ? 'Select user site' : 'Select user location'" persistent-hint
              filled>
              <template slot="append-outer">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">fa fa-question</v-icon>
                  </template>
                  <span>Select user {{ $globalConfig.APP_NAME === 'senso' ? 'site' : 'location'}}</span>
                </v-tooltip>
              </template>
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-content style="padding: 12px 0 0 0;">
                    <v-text-field v-model="searchTerm"
                      :label="$globalConfig.APP_NAME === 'senso' ? 'Search Site' : 'Search Location'"
                      @input="onSearchInput" class="search-term" style="margin:0;"></v-text-field>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
              </template>
            </v-select>
            <v-switch v-model="user.send_mail" class="input_switch mb-5">
              <template v-slot:label>
                <div><strong class="grey800--text">Send welcome email</strong></div>
                <div class="ml-5">
                  <v-tooltip left>
                    <template v-slot:activator="{on}">
                      <v-icon v-on="on">fa fa-question</v-icon>
                    </template>
                    <span>Toggle this on to send this User a welcome email.<br /> This will provide them with their log
                      in details<br /> as well as some top tips on getting started.</span>
                  </v-tooltip>
                </div>
              </template>

            </v-switch>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer absolute height="68">
      <v-flex text-right>
        <v-btn v-if="!loading" color="grey300" class="mr-4 cancel-button" @click="closePanel">Cancel</v-btn>
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn v-else color="dark-blue" class="add-course-button" @click="addUser">Add User</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import userAPI from "@/api/user.js";
import companyAPI from "@/api/company.js";
export default {
  name: "AddGroup",
  props: {
    params: {
      type: String,
      default: null
    },
    locations:{
      type: Array,
      default: null
    }
  },
  data() {
    return {
      roles: [
        {
            name: "User",
            id: 3
        },
        {
            name: "Administrator",
            id: 2
        },
        {
            name: "Team Manager",
            id: 7
        }
      ],
      user: {},
      groups: [],
      messages: {},
      loading: false,
      successMessage: "User Successfully Added.",
      errorMessage: "Oops, something went wrong! Please check information is correct.",
      searchTerm : "",
      locationsCopy : [...this.locations],
    };
  },
  mounted() {
    this.getCompanyDetails();
  },
  computed: {
    filteredLocations() {
      if (!this.searchTerm) {
        return this.locationsCopy; // Return the original list if search is empty
      }
      return this.locationsCopy.filter((location) =>
        location.name.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    },
  },
  methods: {
    closePanel() {
      this.$emit("closePanel", {});
    },
    addUser() {
      this.loading = true;
      userAPI
        .createUser(this.user)
        .then(() => {
          this.closePanel();
          EventBus.$emit("USERS_ADDED", this.params);
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(err => {
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    getCompanyDetails() {
      companyAPI.getCompanyDetails("?include=groups").then(response => {
        this.groups = response.data.data.groups.data;
      });
    },
    customFilter(item, search) {
      // This can be customized as needed for advanced filtering
      return item.name.toLowerCase().includes(search.toLowerCase());
    },
    onSearchInput() {
      // The computed property will handle the filtered list dynamically
    },
    resetSearchTerm() {
        this.searchTerm = ""; // Clear the search term
    },
  }
};
</script>
<style scoped>
.search-term input{
  border-bottom: 1px solid;
}
</style>